export const bniTravelStepperData = [
  {
    key: 'START',
    title_en: 'Start',
    title_ar: 'ابدأ',
  },
  {
    key: 'DATE',
    title_en: 'Trip',
    title_ar: 'الرحلة',
  },
  {
    key: 'PLAN',
    title_en: 'Plan',
    title_ar: 'الخطة',
  },
  {
    key: 'DETAILS',
    title_en: 'Details',
    title_ar: 'بيانات المسافرين',
  },
  {
    key: 'SUMMARY',
    title_en: 'Pay',
    title_ar: 'المراجعة والدفع',
  },
];

export const BNI_TRAVEL_STEP_NAME_START = 'START';
export const BNI_TRAVEL_STEP_NAME_DATE = 'DATE';
export const BNI_TRAVEL_STEP_NAME_DETAILS = 'DETAILS';
export const BNI_TRAVEL_STEP_NAME_PLAN = 'PLAN';
export const BNI_TRAVEL_STEP_NAME_COVERAGE = 'COVERAGE';
export const BNI_TRAVEL_STEP_NAME_SUMMARY = 'SUMMARY';
export const BNI_TRAVEL_STEP_NAME_PAY = 'PAY';

export const bni_travel_insurance_flow = {
  default: [
    {
      name: BNI_TRAVEL_STEP_NAME_START,
      substeps: ['basic_info', 'document_check'],
    },
    {
      name: BNI_TRAVEL_STEP_NAME_DATE,
      substeps: ['flight_details', 'ocr_result', 'edit_trip_info'],
    },
    {
      name: BNI_TRAVEL_STEP_NAME_PLAN,
      substeps: ['plan_selection'],
    },
    {
      name: BNI_TRAVEL_STEP_NAME_DETAILS,
      substeps: ['passenger_details', 'coverage_selection'],
    },
    {
      name: BNI_TRAVEL_STEP_NAME_SUMMARY,
      substeps: ['review_summary'],
    },
  ],
};
